import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

const Page = (props: { children: ReactNode }) => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      w={"full"}
      pl={{ base: 0, md: ".5rem" }}
      sx={{
        "&::-webkit-scrollbar": {
          width: 0,
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          display: "none",
        },
      }}
    >
      {props.children}
    </Box>
  );
};

export default Page;
